import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Panel } from "primereact/panel";
import Swal from "sweetalert2";

import app from "../../firebase-config";

const EditarUsuario = ({ open, onClose, datosUsuario = {} }) => {
  const [empresas, setEmpresas] = useState([]);
  const [nuevaEmpresa, setNuevaEmpresa] = useState("");
  const [form, setForm] = useState({
    nombres: "",
    apellidos: "",
    cargo: "",
    empresa: "",
  });
  const [errors, setErrors] = useState({});
  const labelStyle = {
    display: "block",
    fontWeight: 700,
    color: "#37474f",
    marginBottom: 6,
  };
  const buttonStyle = { borderRadius: 8 };
  const iconFieldStyle = { display: "block", width: "100%" };
  const panelStyle = { borderRadius: 8, overflow: "hidden" };
  const errorTextStyle = {
    color: "#c62828",
    display: "block",
    fontSize: 11,
    fontWeight: 600,
    lineHeight: "14px",
    minHeight: 14,
    marginTop: 4,
  };

  function normalizeValue(value) {
    return value?.toString().trim() || "";
  }

  function setField(field, value) {
    setForm((current) => ({ ...current, [field]: value }));
  }

  function validateForm() {
    const nextErrors = {};

    if (!normalizeValue(form.nombres)) nextErrors.nombres = "Ingrese nombres.";
    if (!normalizeValue(form.apellidos)) nextErrors.apellidos = "Ingrese apellidos.";
    if (!normalizeValue(form.cargo)) nextErrors.cargo = "Ingrese cargo.";
    if (!normalizeValue(form.empresa)) nextErrors.empresa = "Seleccione una empresa.";

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  }

  function renderError(message) {
    return (
      <small style={{ ...errorTextStyle, visibility: message ? "visible" : "hidden" }}>
        {message || "Sin error"}
      </small>
    );
  }

  function showAlert(options) {
    return Swal.fire({
      ...options,
      didOpen: (popup) => {
        const container = Swal.getContainer();
        if (container) container.style.zIndex = "20000";
        if (options.didOpen) options.didOpen(popup);
      },
    });
  }

  function handleClose() {
    setErrors({});
    setNuevaEmpresa("");
    onClose();
  }

  async function crearEmpresa() {
    const nombre = normalizeValue(nuevaEmpresa);
    if (!nombre) return;

    const exists = empresas.some((item) => item.toLowerCase() === nombre.toLowerCase());
    if (exists) {
      setField("empresa", nombre);
      setNuevaEmpresa("");
      return;
    }

    try {
      await app.firestore().collection("empresas").add({ nombre });
      setField("empresa", nombre);
      setNuevaEmpresa("");
    } catch (error) {
      showAlert({ title: "Error", text: "No se pudo crear la empresa.", icon: "error" });
    }
  }

  function guardarUsuario(event) {
    event.preventDefault();
    if (!validateForm()) return;

    showAlert({
      title: "Procesando registro",
      html: "Espere un momento por favor.",
      didOpen: () => Swal.showLoading(),
      allowOutsideClick: false,
    });

    app
      .firestore()
      .collection("users")
      .doc(datosUsuario.idUserAuth)
      .update({
        nombres: normalizeValue(form.nombres),
        apellidos: normalizeValue(form.apellidos),
        cargo: normalizeValue(form.cargo),
        empresa: normalizeValue(form.empresa),
      })
      .then(() => {
        handleClose();
        showAlert({
          title: "Guardar Registro",
          text: "Los cambios se han guardado",
          icon: "success",
        });
      })
      .catch((error) => {
        showAlert({
          title: "Error al guardar",
          text: error.message || "No se pudieron guardar los cambios.",
          icon: "error",
        });
      });
  }

  useEffect(() => {
    const unsubscribe = app
      .firestore()
      .collection("empresas")
      .orderBy("nombre", "asc")
      .onSnapshot((snap) => {
        const docs = snap.docs.map((doc) => doc.data().nombre).filter(Boolean);
        setEmpresas(docs);
      });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!open) return;

    setForm({
      nombres: datosUsuario.nombres || "",
      apellidos: datosUsuario.apellidos || "",
      cargo: datosUsuario.cargo || "",
      empresa: datosUsuario.empresa || "",
    });
    setErrors({});
    setNuevaEmpresa("");
  }, [open, datosUsuario]);

  const empresaOptions = empresas.map((item) => ({ label: item, value: item }));
  const fullName = [datosUsuario.nombres, datosUsuario.apellidos].filter(Boolean).join(" ").trim();

  return (
    <Dialog
      visible={open}
      onHide={handleClose}
      header={
        <div className="d-flex align-items-center" style={{ gap: 10 }}>
          <span
            className="d-inline-flex align-items-center justify-content-center"
            style={{ width: 36, height: 36, borderRadius: 8, backgroundColor: "#e3f2fd", color: "#1565c0" }}
          >
            <i className="pi pi-user-edit"></i>
          </span>
          <span>{`Editar usuario${fullName ? `: ${fullName}` : ""}`}</span>
        </div>
      }
      modal
      draggable={false}
      style={{ width: "820px", maxWidth: "95vw" }}
      contentStyle={{ paddingTop: 12 }}
    >
      <form onSubmit={guardarUsuario}>
        <Panel header="Identidad" className="mb-3" style={panelStyle}>
          <Row gutter={[14, 14]}>
            <Col xs={24} md={8}>
              <label style={labelStyle}>Tipo doc.</label>
              <InputText value={datosUsuario.tipoDoc || ""} disabled className="w-100" />
            </Col>
            <Col xs={24} md={16}>
              <label style={labelStyle}>Numero documento</label>
              <InputText value={datosUsuario.nroDoc || ""} disabled className="w-100" />
            </Col>
            <Col xs={24}>
              <label style={labelStyle}>Correo electronico</label>
              <InputText value={datosUsuario.email || ""} disabled className="w-100" />
            </Col>
          </Row>
        </Panel>

        <Panel header="Datos editables" style={panelStyle}>
          <small className="text-muted d-block mb-3">
            Actualice la informacion operativa del perfil.
          </small>

          <Row gutter={[14, 14]}>
            <Col xs={24} md={12}>
              <label style={labelStyle}>Nombres</label>
              <IconField iconPosition="left" style={iconFieldStyle}>
                <InputIcon className="pi pi-user" />
                <InputText value={form.nombres} onChange={(e) => setField("nombres", e.target.value)} className="w-100" />
              </IconField>
              {renderError(errors.nombres)}
            </Col>
            <Col xs={24} md={12}>
              <label style={labelStyle}>Apellidos</label>
              <IconField iconPosition="left" style={iconFieldStyle}>
                <InputIcon className="pi pi-user" />
                <InputText value={form.apellidos} onChange={(e) => setField("apellidos", e.target.value)} className="w-100" />
              </IconField>
              {renderError(errors.apellidos)}
            </Col>
            <Col xs={24} md={12}>
              <label style={labelStyle}>Cargo</label>
              <IconField iconPosition="left" style={iconFieldStyle}>
                <InputIcon className="pi pi-briefcase" />
                <InputText value={form.cargo} onChange={(e) => setField("cargo", e.target.value)} className="w-100" />
              </IconField>
              {renderError(errors.cargo)}
            </Col>
            <Col xs={24} md={12}>
              <label style={labelStyle}>Empresa</label>
              <Dropdown
                value={form.empresa}
                options={empresaOptions}
                onChange={(e) => setField("empresa", e.value)}
                className="w-100"
                placeholder="Seleccione empresa"
              />
              {renderError(errors.empresa)}
            </Col>
            <Col xs={24}>
              <label style={labelStyle}>Crear nueva empresa</label>
              <div className="d-flex" style={{ gap: 8 }}>
                <IconField iconPosition="left" style={iconFieldStyle}>
                  <InputIcon className="pi pi-building" />
                  <InputText
                    value={nuevaEmpresa}
                    onChange={(e) => setNuevaEmpresa(e.target.value)}
                    className="w-100"
                    placeholder="Nombre de empresa"
                  />
                </IconField>
                <Button
                  type="button"
                  icon="pi pi-plus"
                  severity="success"
                  disabled={!nuevaEmpresa.trim()}
                  onClick={crearEmpresa}
                  style={buttonStyle}
                />
              </div>
            </Col>
          </Row>
        </Panel>

        <div
          className="d-flex justify-content-end mt-4 pt-3"
          style={{ gap: 8, borderTop: "1px solid #e8eef4" }}
        >
          <Button type="button" label="Cancelar" icon="pi pi-times" severity="secondary" outlined onClick={handleClose} style={buttonStyle} />
          <Button type="submit" label="Guardar Cambios" icon="pi pi-save" severity="success" style={buttonStyle} />
        </div>
      </form>
    </Dialog>
  );
};

export default EditarUsuario;
